import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpGetMeasureSubTypes} from '@/features/measures/services/measures.http.ts'

export const useGetMeasuresSubTypes = () => {
    return useQuery({
        queryKey: [QUERY_KEYS.MEASURE_SUB_TYPES],
        queryFn: httpGetMeasureSubTypes
    })
}
